var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssaabloyKeySoftware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Assaabloy_key_software"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assaabloy_key_software",
    "data-name": "Assaabloy key software",
    clipPath: "url(#clip-Assaabloy_key_software)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "key_14251242",
    transform: "translate(-2.5 -2.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M101.684,50.807H94.5A42.806,42.806,0,0,1,21.417,81.084a41.236,41.236,0,0,1-3.411-3.867l4.956-7.1A34.6,34.6,0,0,0,86.273,50.807H79.1L89,36.651l1.389-1.978Z",
    transform: "translate(0.816 1.334)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M86.189,25.741,81.222,32.83A34.6,34.6,0,0,0,17.911,52.141h7.178l-.433.611L13.8,68.274l-1.956-2.789L2.5,52.141H9.689a42.776,42.776,0,0,1,76.5-26.4Z",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M58.663,49.337a14.912,14.912,0,1,0-6.9,8.263h2.106v3.726H57.6v3.731h3.726v3.726h3.731v3.731h7.458V63.19ZM40.817,44.543a3.729,3.729,0,1,1,3.726-3.726A3.73,3.73,0,0,1,40.817,44.543Z",
    transform: "translate(1.428 1.069)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssaabloyKeySoftware);
export default __webpack_public_path__ + "static/media/assaabloy-key-software.57ea622c8f4f4a27acb4bb9a34172c56.svg";
export { ForwardRef as ReactComponent };